/* eslint-disable indent */
import { memo, useEffect, useMemo } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useStore } from '../../../core/utils/hook';
import BannerTopPage from './_components/BannerTopPage/BannerTopPage';
import ServicesTopPage from './_components/ServicesTopPage/ServicesTopPage';
import IntroductionTopPage from './_components/IntroductionTopPage/IntroductionTopPage';
import PriceTopPage from './_components/PriceTopPage/PriceTopPage';
import PecStepTopPage from './_components/PecStepTopPage/PecStepTopPage';
import FaqTopPage from './_components/FaqTopPage/FaqTopPage';
import { handleScrollToId } from '../../../core/utils/scroll';
import { TOP_PAGE_THEME_TYPE } from '../../../core/configs/constants';

import './styles.scss';

/* eslint-disable max-len */
const TopPageScreenNew = observer(({ typeTheme }) => {
    // hook
    const location = useLocation();
    const navigate = useNavigate();

    // store
    const {
        authStore: { token, userInfo, showLoadingSrc },
        userStore: { userInfoHeader, getProfile },
        themeStore: { getAllThemes },
        courseStore: { getAllCourses, cleanPagingHomeCourses, cleanRecommendCourses, getTrainingCourseList, cleanTrainingCourseList },
        ticketStore: { getAllTickets, tickets },
        generalSettingStore: { getGeneralSetting, generalSetting: { faqs } },
        modalStore: { show, hide },
        messageStore: { getMessagePopup },
        informationStore: { getAllInformationsForStudent },
        notifyStore: { getNotifies, cleanNotifiesPaging },
        shareKnowledgeStore: { getAllFileShareknowledge, clearLstFileShareknowledge },
        settingTopPageStore: { themeTopPage, getThemeTopPage },
        apiStore: { loading }
    } = useStore();

    // lifecycle
    useEffect(() => {
        getThemeTopPage(
            typeTheme === TOP_PAGE_THEME_TYPE.PREVIEW
                ? TOP_PAGE_THEME_TYPE.PREVIEW
                : undefined
        );
    }, [typeTheme, getThemeTopPage]);

    useEffect(() => {
        cleanPagingHomeCourses();
        cleanRecommendCourses();

        getAllTickets({ status: 1 });
        getGeneralSetting({ type: 'faqs' });

        return () => {
            cleanTrainingCourseList();
            clearLstFileShareknowledge();
            cleanNotifiesPaging();
        }
    }, [])

    // Scroll to section id
    useEffect(() => {
        if (!showLoadingSrc && !loading && (location.hash || location.state?.scrollTo)) {
            const idSCrollTo = location.hash || location.state?.scrollTo;

            const timer = setTimeout(() => {
                handleScrollToId(idSCrollTo, location.state?.offset || 0);
                navigate(location.pathname, { replace: true });
            }, 0);

            // cleanup
            return () => clearTimeout(timer);
        }
    }, [location, showLoadingSrc, loading]);

    // const
    const [whatIsElephant, contentIntroduction, ticketPlan, faq] = useMemo(() => {
        const elephantData = toJS(themeTopPage?.whatIsElephant);
        const introductionData = toJS(themeTopPage?.contentIntroduction);
        const ticketData = toJS(themeTopPage?.ticketPlan);
        const faqData = toJS(themeTopPage?.faq);

        return [elephantData, introductionData, ticketData, faqData];
    }, [themeTopPage]);


    return (
        <div id='main' className='wrapper std-home-screen' style={{ color: '#000' }}>

            <BannerTopPage />

            <ServicesTopPage whatIsElephant={whatIsElephant} />

            <IntroductionTopPage contentIntroduction={contentIntroduction} />

            <PriceTopPage ticketPlan={ticketPlan} />

            <PecStepTopPage />

            <FaqTopPage faq={faq} />

        </div>
    )
});

export default memo(TopPageScreenNew);
